<template>
	<v-container fluid>
		<v-row>
			<v-col class="pa-6 pt-2">
				<v-sheet tile height="72" color="calendar" class="d-flex">
					<v-col cols="4" md="4">
						<v-btn icon class="ma-2" @click="$refs.calendar.prev()">
							<v-icon>fas fa-arrow-left</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="4" md="4" class="text-center">
						<strong v-if="$refs.calendar">{{ $refs.calendar.title }} </strong></v-col
					>
					<v-col cols="4" md="4" class="text-right">
						<v-btn icon class="ma-2" @click="$refs.calendar.next()">
							<v-icon>fas fa-arrow-right</v-icon>
						</v-btn></v-col
					>
				</v-sheet>
				<v-sheet height="950">
					<v-calendar
						locale="hr-HR"
						ref="calendar"
						v-model="calendarInfo.value"
						type="week"
						:event-color="getEventColor"
						:events="calendarInfo.events"
						@click:event="eventClick"
						@change="getAppointments"
						event-overlap-mode="column"
						first-time="06:00"
					>
						<template v-slot:event="{ event }">
							<div class="event-wrapper">
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<div class="event-data" v-on="on">
											{{ event.course_name }}
											<br />
											{{ event.module_name }}
											<br />
											{{ event.teacher_name }}
											<br />
											{{ formatTime(event.start) + ' - ' + formatTime(event.end) }}
										</div>
									</template>
									<div>
										{{ event.course_name }}
										<br />
										{{ event.module_name }}
										<br />
										{{ event.teacher_name }}
										<br />
										{{ formatTime(event.start) + ' - ' + formatTime(event.end) }}
									</div>
								</v-tooltip>
							</div>
						</template>
					</v-calendar>
				</v-sheet>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Calendar',
	components: {},
	props: {
		appointmentLocationId: [Number, String],
	},
	emits: ['appointmentFetched'],
	data() {
		return {
			calendarInfo: {
				value: '',
				events: [],
			},
		};
	},
	watch: {
		appointmentLocationId(newVal) {
			if (newVal !== null) {
				this.getAppointments();
			}
		},
	},
	computed: {},
	methods: {
		getEventColor(event) {
			return event.color;
		},
		formatTime(dateTime) {
			const date = new Date(dateTime);
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			return `${hours}:${minutes}`;
		},
		getAppointments() {
			let vm = this;
			let payload = {
				data: {
					end_date: this.$refs.calendar.lastEnd.date,
					start_date: this.$refs.calendar.lastStart.date,
					appointment_location_id: this.appointmentLocationId,
				},
			};
			this.$APICall(
				'get',
				'appointments-weekly-events',
				payload,
				(data, succes) => {
					if (succes) {
						vm.calendarInfo.events = [];
						vm.calendarInfo.events = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		eventClick(event) {
			let plannedCourseId = event.event.id;
			this.$router.push('/planned-courses/' + plannedCourseId);
		},
	},
	mounted() {},
};
</script>

<style scoped>
.event-wrapper {
	padding: 5px;
	color: white;
	border-radius: 3px;
}

.event-data {
	font-weight: bold;
	white-space: normal;
	max-width: 300px;
	text-overflow: ellipsis;
}
</style>
